import { BarcodeOutlined } from "@ant-design/icons";
import { Button, Modal,Row,Col } from "antd";
import React, { useEffect, useState } from "react";
import { ApiRequest } from "../../../../services/api/api";
import { emptyImg, JadCupImg } from "../../../../services/others/assets";
import productStickersPdfGenerate from "../../../static/pdf/product-stickers/product-stickers-pdf-generate_all";
import { IStickerPdf } from "../../../../services/model/IStickerPdf";

const ShowBoxBarCodeModal = (props: {
  boxBarCodeModalVisible: boolean;
  closeModal: any;
  groupArray: any;
}) => {
  const {groupArray} = props
  const [base64, setBase64] = useState(String)  
  const [data, setData] = useState<any>()    
  const [prod, setProd] = useState<any>()  
  const [barCodeWorkOrderNo, setBarCodeWorkOrderNo] = useState<any>()   

  useEffect(() => {
      setBase64(String)
      if (!groupArray) return
      let prodid = groupArray[0]?.key?.product?.productId;
      if (!prodid) return

      // const barCodeList = groupArray.map((item: any) => item.title.barCode);
      // ApiRequest({
      //   url: 'Box/GetWorkOrderNoByBarcodes',
      //   method: 'post',
      //   data: barCodeList
      // }).then(res => {
      //   const responseData = res.data.data
      //   setBarCodeWorkOrderNo(responseData);
      // })
      setBarCodeWorkOrderNo("")
      // setProd();
      ApiRequest({
        url: 'Product/GetProductById?Id=' +prodid,
        method: 'get'
      }).then(res => {
        const responseData = res.data.data
        setProd(responseData);
        getImg(responseData.logoType, responseData.logoUrl)
      })


  }, [groupArray])  
  const getImg = (logoType:number, logoUrl:string) => {
    if (logoType == 2) {
      setBase64(emptyImg)
    } else if (logoType == 1 ) {
      const imgUrl = logoUrl?.split('---')[0] ? JSON.parse(logoUrl?.split('---')[0])?.url : ""
      getBase64FromUrl(imgUrl)
    } else {
      setBase64(JadCupImg)
    }
  }
  const getBase64FromUrl = (url: string) => {
    ApiRequest({
      url: 'Common/UrltoBase64?imageFile=' + url,
      method: 'get'
    }).then(res => {
      const responseData = res.data
      setBase64('data:image/png;base64,' + responseData)
    })
  }

  const ProductDetailInPdf = async (): Promise<IStickerPdf[]> => {
    const product = prod.productName
    const logoType = prod.logoType
    const logoUrl = prod.logoUrl
    const productCode = prod.productCode
    const custProductCode = prod.custProductCode
    const packaging =  prod?.baseProduct?.packagingType?.sleevePkt + 'pcs X '
                    + prod?.baseProduct?.packagingType?.sleeveQty + 'pk'
    const sleevePkt = prod?.baseProduct?.packagingType?.sleevePkt
    const madeInNz = (prod.logoType != 3) ? 'Made In New Zealand' : ''
    // debugger
    const grossWeigh = prod?.baseProduct?.grossWeigh
    const cartonLength = prod?.baseProduct?.cartonLength
    const cartonWidth = prod?.baseProduct?.cartonWidth
    const cartonHeight = prod?.baseProduct?.cartonHeight
    const productDetail: IStickerPdf[] = props.groupArray.map((item: any) => {
      return {
        barcode: item.title.barCode,
        productName: product,
        logoType: logoType,
        logoUrl: logoUrl,
        logoBase64: base64,
        productCode: productCode,
        custProductCode: custProductCode,
        packaging: packaging,
        sleevePkt: sleevePkt,
        madeInNz: madeInNz,
        testLog: JadCupImg,
        manufactureDate: item.title.createdAt,
        batchNumber:item.workOrderNo,
        grossWeigh:grossWeigh,
        cartonLength:cartonLength,
        cartonWidth:cartonWidth,
        cartonHeight:cartonHeight,
        quantity:item.title.quantity??""
      }
    })
    return productDetail
  }  
  const onPrint = async () => {
    const productDetail = ProductDetailInPdf()
    productStickersPdfGenerate(await productDetail, 'view')
  }
  return (
    <Modal
      width={800}
      destroyOnClose={true}
      visible={props.boxBarCodeModalVisible}
      closable={false}
      footer={[
        <Button key="submit" type="primary" onClick={props.closeModal}>
          Close
        </Button>,
        prod && <Button key="" type="primary" onClick={onPrint}>
          Print
        </Button>
      ]}
    >
      <h3>List of Bar Code</h3>
      <div >
        <Row>
        {props.groupArray?.map((item: any) => (
          item.title.boxCode ?
            <Col span={6} key={item.title.boxCode}><BarcodeOutlined style={{ fontSize: '16px', color: '#08c' }}/>{item.title.boxCode}</Col> :
            <Col span={6} key={item.title.barCode}><BarcodeOutlined style={{ fontSize: '16px', color: '#08c' }}/>{item.title.barCode}</Col>
        ))}
        </Row>
      </div>
    </Modal>
  );
};

export default ShowBoxBarCodeModal;

